'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsOverviewComponent = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newsOverviewComponent = exports.newsOverviewComponent = {
    template: require('./news-overview.html'),
    bindings: {
        model: '<',
        viewMode: '@',
        itemsPerPageChanged: '&',
        selectedCategory: '<',
        badgeClicked: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "Analytics", function newsOverviewController($scope, $state, Analytics) {
        'ngInject';

        var vm = this;

        vm.search = search;
        vm.clear = clear;
        vm.onKeydown = onKeydown;
        vm.goToPage = goToPage;
        vm.selectCategoriesChanged = selectCategoriesChanged;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.pagecountList = [12, 24, 36];
        vm._badgeClicked = _badgeClicked;

        function search() {
            Analytics.trackEvent('News', 'newsSearch', vm.model.searchValue, 0, true);
            $state.go('.', { page: 1, searchValue: vm.model.searchValue });
        }

        function clear() {
            vm.model.searchValue = null;
            $state.go('.', { page: 1, searchValue: vm.model.searchValue });
        }

        function onKeydown() {
            if (event.keyCode === 13) {
                // keyIdentifier = 'Enter'
                $state.go('.', { page: 1, searchValue: vm.model.searchValue });

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
        }

        function goToPage(page) {
            if (page === 0 || page > vm.model.paging.pageCount) {
                return;
            }
            $state.go('.', { page: page });
        }

        // function goToPage(page) {
        //     if (page === 0 || page > vm.paging.pageCount) { return; }
        //     vm.paging.page = page;
        //     getOrders();
        // }

        /* paging */
        function changeItemsPerPage(_ref) {
            var itemsPerPage = _ref.itemsPerPage;

            vm.model.paging.itemsPerPage = itemsPerPage;
            $state.go('.', { page: 1 });
            vm.itemsPerPageChanged({ $event: itemsPerPage });
        }

        function selectCategoriesChanged() {
            $state.go('.', { page: 1, categoryId: vm.model.selectedCategory.id });
        }

        function _badgeClicked(categoryId) {
            vm.model.selectedCategory = _lodash2.default.find(vm.model.categories, function (i) {
                return i.id === categoryId;
            });
            vm.badgeClicked({ categoryId: categoryId });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-overview.js
// module id = 946
// module chunks = 0